/* Title + Icon container */
.spotify-player-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 0.5em;
  width: 100%;
}

/* Tabs */
.spotify-player-tabs {
  display: flex;
  gap: 0.5em;
  justify-content: center;
  flex: 1 1 auto;
}

.spotify-player-default-layout .spotify-player-tabs,
.spotify-player-widescreen-layout .spotify-player-tabs {
  margin-left: 0.5em;
}

.spotify-player-portrait-layout .spotify-player-header {
  flex-direction: column;
  align-items: stretch;
}

.spotify-player-portrait-layout .spotify-player-tabs {
  justify-content: space-evenly;
}

/* Active indicator on settings tab when sleep timer is running */
.spotify-player-tab-badge {
  position: relative;
}

.spotify-player-tab-badge::after {
  content: "";
  position: absolute;
  top: 2px;
  right: 2px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--accent-color);
}

.spotify-player-tab {
  background-color: var(--button-background);
  color: var(--button-text-color);
  border: 1px solid var(--button-border);
  border-radius: 0.3em;
  padding: 0.4em 1em;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  flex: 1;
}

.spotify-player-tab:hover {
  background-color: var(--accent-color);
  color: var(--darkest);
}

.spotify-player-tab:disabled {
  background-color: var(--button-border);
  color: var(--description-color);
  cursor: not-allowed;
}

.spotify-player-tab-active {
  background-color: var(--button-hover-background);
  color: var(--accent-color);
  font-weight: bold;
}

.spotify-player-back-button {
  background: none;
  border: 1px solid var(--grey);
  color: var(--lightest);
  cursor: pointer;
  height: 2em;
  padding: 0;
  border-radius: 50%;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  transition: width 0.2s ease, height 0.2s ease, opacity 0.2s ease, transform 0.2s ease, border-color 0.2s ease, margin 0.2s ease;
}

.spotify-player-back-visible {
  width: 2em;
  opacity: 1;
  transform: translateX(0);
  margin-right: 0.5em;
}

.spotify-player-back-hidden {
  width: 0;
  height: 0;
  opacity: 0;
  border-color: transparent;
  pointer-events: none;
  transform: translateX(-0.5em);
  margin: 0;
  padding: 0;
}

.spotify-player-back-button:hover {
  background-color: var(--accent-color);
  color: var(--darkest);
  transition: background-color 0.15s ease, color 0.15s ease, width 0.2s ease, opacity 0.2s ease, transform 0.2s ease;
}

.spotify-player-device-title {
  display: flex;
  align-items: center;
  gap: 1em;
  text-align: center;
  background-color: var(--dark);
  flex: 1 1 auto;
  min-width: 0;
  justify-content: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  padding: 0.4em;
  border-radius: 0.2em;
  overflow: hidden;
}


/* Title device name styling */

.spotify-player-device-title h4 {
  font-weight: bold;
  font-size: 1.5rem;
  color: var(--weird);
  margin: 0;
  transition: transform 0.2s, color 0.3s ease;
}

.spotify-player-device-title:hover h4 {
  transform: scale(1.1);
  color: var(--yellow);
}

/* Title Icon styling */

.spotify-player-connected-icon {
  font-size: 2rem;
  color: var(--lightest);
}

.spotify-player-connected-icon.spotify-player-disconnected {
  color: var(--red);
}

.spotify-player-connected-icon.spotify-player-rotating {
  animation: rotate 2s linear infinite;
  color: var(--blue);
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(20deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(-20deg);
  }
  100% {
    transform: rotate(-0deg);
  }
}
